export default (url) => {
  const link = document.createElement('a');
  link.setAttribute('href', `${API_URL}/${url}`);
  document.body.appendChild(link); // Required for FF
  link.click();
  document.body.removeChild(link); // Required for FF
};
